import { $UserAgent } from '@lemon8/web-app-shared/atom';
import { useAtomValue } from 'jotai';

export interface IIOSVersion {
  major: number;
  minor: number;
}

export const useIOSVersion: () => IIOSVersion | null = () => {
  const { userAgent } = useAtomValue($UserAgent);
  const iOSRegex = /iP(?:hone|ad).*?\sOS\s(\d+)[_\.](\d+)([_\d]*)/;
  const match = userAgent.match(iOSRegex);

  if (match) {
    const majorVersion = parseInt(match[1], 10);
    const minorVersion = parseInt(match[2], 10);
    return {
      major: majorVersion,
      minor: minorVersion,
    };
  }

  return null;
};
